import type { CiaDependencies } from '~/composables/useCia/types';

type NewsletterSubscriptionProgressRequest = {
  locale: string;
  email: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, languageAndCountry } = dependencies;

  return async (email?: string): Promise<any | undefined> => {

    if (!email) {

      return Promise.resolve();
    
    }

    const payload: NewsletterSubscriptionProgressRequest = {
      locale: languageAndCountry,
      email,
    };

    return fetch('/cia/newsletter-subscription-progress', {
      method: 'POST',
      body: payload,
    });
  
  };

};
